import React from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';

const AmountCell = ({ measureInfo, dataItem, field, rowType }) => {
  const intl = useInternationalization();

  if (rowType === 'groupHeader') {
    return null;
  }

  //let formattedAmount = intl.toString(dataItem[field] * dataItem.operatorApplied, 'n2');
  let formattedAmount = intl.toString(dataItem[field], 'n2');

  return (
    <td>
      <div className="alignment-right">{measureInfo ? formattedAmount : dataItem[field]}</div>
    </td>
  );
};

export default AmountCell;
